import React, { useEffect, useState } from "react";
import { listProducts, listBlog, fetchSiteContent } from "../lib/api";
import HeroSection from "../components/home/HeroSection";
import MarqueeStrip from "../components/home/MarqueeStrip";
import PillarsSection from "../components/home/PillarsSection";
import ValueProps from "../components/home/ValueProps";
import FeatureVideo from "../components/home/FeatureVideo";
import CategoriesSection from "../components/home/CategoriesSection";
import FeaturedShirts from "../components/home/FeaturedShirts";
import KurtaTrio from "../components/home/KurtaTrio";
import JournalSection from "../components/home/JournalSection";
import BigCTA from "../components/home/BigCTA";

export default function Home() {
  const [shirts, setShirts] = useState([]);
  const [kurtas, setKurtas] = useState([]);
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState(null);

  useEffect(() => {
    listProducts({ category: "shirts" })
      .then((d) => setShirts(d.slice(0, 4)))
      .catch(() => {});
    listProducts({ category: "kurtas" })
      .then(setKurtas)
      .catch(() => {});
    listBlog()
      .then((d) => setPosts(d.slice(0, 4)))
      .catch(() => {});
    fetchSiteContent().then(setContent).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <HeroSection hero={content?.hero || {}} />
      <MarqueeStrip items={content?.marquee} />
      <PillarsSection
        eyebrow={content?.pillars_eyebrow}
        heading={content?.pillars_heading}
        pillars={content?.pillars}
      />
      <ValueProps />
      <FeatureVideo data={content?.feature_video} />
      <CategoriesSection data={content?.categories} />
      <FeaturedShirts shirts={shirts} />
      <KurtaTrio kurtas={kurtas} />
      <JournalSection posts={posts} />
      <BigCTA data={content?.big_cta} />
    </div>
  );
}
